<template>
  <v-card id="infotable" max-width="350" width="100%" flat color="lsidebg" class="mb-3 mr-sm-3 mr-md-0 pb-2" > 
    <div :class="contentType">
      <v-card-title class="pb-0 pl-2 mb-0" style="padding-top:6.5px;">
        <h5 class="wdgt-title" >{{titleText}}</h5>
      </v-card-title>
    </div>

    <v-card-text class="px-2 pt-2 pb-0" >
      <template v-for="(row, id) in tableContent">
        <v-row no-gutters :key="'row' + id">
          <v-col cols="3" md="4" class="pt-0 pb-1">
            <span class="spec_infolabel darkgrey-text">{{row.name}}</span> 
          </v-col>
          <v-col cols="8" class="pt-0 pb-1 pl-1">
            <span v-if="isArray(row.value)">  <!-- the entry is an array -->
              <div v-for="(item, id) in row.value" class="pa-0" :key="id">
                <span v-if="item.link" class="spec_infoval darkgrey-text"><router-link  :to="item.link">{{item.text}}</router-link></span> <!-- the data in the array contains a link (internal) -->
                <span v-else class="spec_infoval darkgrey-text">{{item.text}}</span>  <!-- the data in the array is plan text -->
              </div>
            </span>

            <span v-else class="spec_infoval darkgrey-text">{{row.value}}</span>  <!-- the entry is kusta text -->
          </v-col>
        </v-row>
        <v-divider role="presentation" class="mb-1" :key="'line' + id"></v-divider>
      </template>
    </v-card-text>
  </v-card>

</template>
<script>
  export default {
    name: 'InfoTable',
    props: {
      titleText: String,
      tableContent: Array,
      contentType:String,
    },
    methods: {
      isArray(obj){
        return Array.isArray(obj)
      }
    }
  }
</script>
<style scoped lang="scss">
  @import '@/sass/_typography.scss';

  a {
    @include link-no-underline-block-hover;
  }

  .spec_infolabel{
    font-size: 8.2pt;
    font-stretch: semi-condensed;
    word-break: normal;
    line-height: 0.8;
  }

  .spec_infoval{
    font-size: 9.5pt;
    font-weight: 600;
    word-break: normal;
    line-height: 0.8;
  }
</style>